<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <!-- <ng-template pTemplate="left">
                <h6 style="margin-right: 20px;">Select Financial Year: </h6>
                <p-dropdown  [options]="financialYears" [(ngModel)]="selectedYear" [editable]="true" optionLabel="name" (onChange)="financialYearChange($event)"></p-dropdown>
            </ng-template> -->
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="consolidateData"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'District',
		'Block',
		'Constituency',
        'totalApp',
		'TotalArea',
		'VerifiedApp',
		'verifiedAppArea',
		'PendingApp',
		'IncompleteApp',
		'incompleteAppArea',
		'rejectApp',
		'totalEstimatedApp',
		'totalEstimatedArea',
		'verifiedEstimateApp',
		'verifiedEstimateArea',
		'pendingEstimateApp',
		'verifiedEstApproved',
		'verifiedEstApprovedArea',
		'pendingEstApproved',
		'rejectedEstVerified',
		'ChallanGenerated',
		'ChallanDeposited',
		'BOQUploaded',
		'BOQMIArea',
		'BOQPending',
		'PVCompleted',
		'PV_MI_Area',
		'PV_Pending_with_JE',
		'PV_Pending_with_XEN',
		'Pending_Subsidy_Calculation',
		'ApplicationswithDMIforSubsidy_Approval',
		'Applications_Approved_at_Administartion',
		'Subsisdy_Approved_MI_Area',
		'AssistanceAmount',
		'Pending_Application_For_Payment_By_CAO',
		'Payment_Done_Application_By_CAO',
		'Payment_done_MI_Area',


        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'MI_CONSOLIDATED_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [ngClass]="{'row-accessories': true}"></th>

                <th [ngClass]="{'row-accessories': true}"></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                
                <th></th>
                <th></th>
                <th></th>
                <th>{{'APPLICATION_APPROVAL1'| translate}}</th>
                
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                
                <th [ngClass]="{'row-accessories': true}"></th>
                <th></th>
                <th></th>
                <th>{{'ESTIMATE'| translate}} </th>
                <th></th>
                <th></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                
                <th></th>
                <th>{{'ESTIMATE_APPROVAL1'| translate}}</th>
                <th></th>
                <th></th>

                <th [ngClass]="{'row-accessories': true}"></th>

                <th>{{'CHALLAN1'| translate}}</th>
                <th></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th></th>
                <th>{{'BOQ'| translate}}</th>
                <th></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th></th>
                <th></th>
                <th>{{'PV'| translate}}</th>
                <th></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th></th>
                <th></th>
                <th>{{'SUBSIDY_CALCULATION1'| translate}}</th>
                <th></th>
                <th></th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th></th>
                <th>{{'SUBSIDY'| translate}}</th>
                <th></th>
                

                 
            </tr>
            <tr>
                             
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                    <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                    <p-sortIcon field="Constituency"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="totalApp">{{'TOTAL_APP'| translate}}
                    <p-columnFilter type="text" field="totalApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="totalApp"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                    <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalArea"></p-sortIcon>
                </th>
                <th pSortableColumn="VerifiedApp">{{'VERIFIED_APP'| translate}}
                    <p-columnFilter type="text" field="VerifiedApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="VerifiedApp"></p-sortIcon>
                </th>
                <th pSortableColumn="verifiedAppArea">{{'VERIFIED_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedAppArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedAppArea"></p-sortIcon>
                </th>
                <th pSortableColumn="PendingApp">{{'PENDING_APP'| translate}}
                    <p-columnFilter type="text" field="PendingApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingApp"></p-sortIcon>
                </th>
                <th pSortableColumn="IncompleteApp">{{'INCOMPLETE_APP'| translate}}
                    <p-columnFilter type="text" field="IncompleteApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="IncompleteApp"></p-sortIcon>
                </th>
                <th pSortableColumn="incompleteAppArea">{{'INCOMPLETE_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="incompleteAppArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="incompleteAppArea"></p-sortIcon>
                </th>
                <th pSortableColumn="rejectApp">{{'REJECTED_APP'| translate}}
                    <p-columnFilter type="text" field="rejectApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="rejectApp"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="totalEstimatedApp">{{'TOTAL_ESTIMATED_APP'| translate}}
                    <p-columnFilter type="text" field="totalEstimatedApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="totalEstimatedApp"></p-sortIcon>
                </th>
                <th pSortableColumn="totalEstimatedArea">{{'TOTAL_ESTIMATED_AREA'| translate}}
                    <p-columnFilter type="text" field="totalEstimatedArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="totalEstimatedArea"></p-sortIcon>
                </th>
                <th pSortableColumn="pendingEstimateApp">{{'PENDING_ESTIMATE_APP'| translate}}
                    <p-columnFilter type="text" field="pendingEstimateApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingEstimateApp"></p-sortIcon>
                </th>
                <th pSortableColumn="verifiedEstimateApp">{{'VERIFIED_ESTIMATE_APP'| translate}}
                    <p-columnFilter type="text" field="verifiedEstimateApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstimateApp"></p-sortIcon>
                </th>
                <th pSortableColumn="verifiedEstimateArea">{{'VERIFIED_ESTIMATE_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedEstimateArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstimateArea"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                
                <th pSortableColumn="verifiedEstApproved">{{'VERIFIED_ESTIMATE_APPROVED'| translate}}
                    <p-columnFilter type="text" field="verifiedEstApproved" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstApproved"></p-sortIcon>
                </th>
                <th pSortableColumn="verifiedEstApprovedArea">{{'VERIFIED_ESTIMATE_APPROVED_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedEstApprovedArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstApprovedArea"></p-sortIcon>
                </th>
                <th pSortableColumn="pendingEstApproved">{{'PENDING_ESTIMATE_APPROVED'| translate}}
                    <p-columnFilter type="text" field="pendingEstApproved" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingEstApproved"></p-sortIcon>
                </th>
                <th pSortableColumn="rejectedEstVerified">{{'REJECTED_ESTIMATE_VERIFIED'| translate}}
                    <p-columnFilter type="text" field="rejectedEstVerified" display="menu"></p-columnFilter>
                    <p-sortIcon field="rejectedEstVerified"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="ChallanGenerated">{{'CHALLAN_GENERATED'| translate}}
                    <p-columnFilter type="text" field="ChallanGenerated" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanGenerated"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanDeposited">{{'CHALLAN_DEPOSITED'| translate}}
                    <p-columnFilter type="text" field="ChallanDeposited" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanDeposited"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="BOQUploaded">{{'BOQ_UPLOADED'| translate}}
                    <p-columnFilter type="text" field="BOQUploaded" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQUploaded"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQMIArea">{{'BOQ_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="BOQMIArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQMIArea"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQPending">{{'BOQ_PENDING'| translate}}
                    <p-columnFilter type="text" field="BOQPending" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQPending"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="PVCompleted">{{'PV_COMPLETED'| translate}}
                    <p-columnFilter type="text" field="PVCompleted" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVCompleted"></p-sortIcon>
                </th>
                <th pSortableColumn="PV_MI_Area">{{'PV_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="PV_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_MI_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="PV_Pending_with_JE">{{'PV_PENDING_WITH_JE'| translate}}
                    <p-columnFilter type="text" field="PV_Pending_with_JE" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Pending_with_JE"></p-sortIcon>
                </th>
                <th pSortableColumn="PV_Pending_with_XEN">{{'PV_PENDING_WITH_XEN'| translate}}
                    <p-columnFilter type="text" field="PV_Pending_with_XEN" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Pending_with_XEN"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="Pending_Subsidy_Calculation">{{'PENDING_SUBSIDY_CALCULATION'| translate}}
                    <p-columnFilter type="text" field="Pending_Subsidy_Calculation" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Subsidy_Calculation"></p-sortIcon>
                </th>
                <th pSortableColumn="ApplicationswithDMIforSubsidy_Approval">{{'APP_WITH_DMI_SUBSIDY_APPROVAL'| translate}}
                    <p-columnFilter type="text" field="ApplicationswithDMIforSubsidy_Approval" display="menu"></p-columnFilter>
                    <p-sortIcon field="ApplicationswithDMIforSubsidy_Approval"></p-sortIcon>
                </th>
                <th pSortableColumn="Applications_Approved_at_Administartion">{{'APP_APPROVED_AT_ADMINISTRATION'| translate}}
                    <p-columnFilter type="text" field="Applications_Approved_at_Administartion" display="menu"></p-columnFilter>
                    <p-sortIcon field="Applications_Approved_at_Administartion"></p-sortIcon>
                </th>
                <th pSortableColumn="Subsisdy_Approved_MI_Area">{{'SUBSIDY_APPROVED_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Subsisdy_Approved_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Subsisdy_Approved_MI_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="AssistanceAmount">{{'ASSISTANCE_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="AssistanceAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="AssistanceAmount"></p-sortIcon>
                </th>
                <th [ngClass]="{'row-accessories': true}"></th>
                <th pSortableColumn="Pending_Application_For_Payment_By_CAO">{{'PENDING_APP_FOR_PAYMENT_BY_CAO'| translate}}
                    <p-columnFilter type="text" field="Pending_Application_For_Payment_By_CAO" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Application_For_Payment_By_CAO"></p-sortIcon>
                </th>
                <th pSortableColumn="Payment_Done_Application_By_CAO">{{'PAYMENT_DONE_APP_BY_CAO'| translate}}
                    <p-columnFilter type="text" field="Payment_Done_Application_By_CAO" display="menu"></p-columnFilter>
                    <p-sortIcon field="Payment_Done_Application_By_CAO"></p-sortIcon>
                </th>
                <th pSortableColumn="Payment_done_MI_Area">{{'PAYMENT_DONE_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Payment_done_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Payment_done_MI_Area"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-consolidateData>
            <tr>
                <td>{{consolidateData.District}}</td>
                <td>{{consolidateData.Block}}</td>
                <td>{{consolidateData.Constituency}}</td>
                <td></td>
                <td>{{consolidateData.totalApp}}</td>
                <td>{{consolidateData.TotalArea}}</td>
                <td>{{consolidateData.VerifiedApp}}</td>
                <td>{{consolidateData.verifiedAppArea}}</td>
                <td>{{consolidateData.PendingApp}}</td>
                <td>{{consolidateData.IncompleteApp}}</td>
                <td>{{consolidateData.incompleteAppArea}}</td>
                <td>{{consolidateData.rejectApp}}</td>
                <td></td>
                <td>{{consolidateData.totalEstimatedApp}}</td>
                <td>{{consolidateData.totalEstimatedArea}}</td>
                <td>{{consolidateData.pendingEstimateApp}}</td>
                <td>{{consolidateData.verifiedEstimateApp}}</td>
                <td>{{consolidateData.verifiedEstimateArea}}</td>
                <td></td>
                
                
                <td>{{consolidateData.verifiedEstApproved}}</td>
                <td>{{consolidateData.verifiedEstApprovedArea}}</td>
                <td>{{consolidateData.pendingEstApproved}}</td>
                <td>{{consolidateData.rejectedEstVerified}}</td>
                <td></td>
                <td>{{consolidateData.ChallanGenerated}}</td>
                <td>{{consolidateData.ChallanDeposited}}</td>
                <td></td>
                <td>{{consolidateData.BOQUploaded}}</td>
                <td>{{consolidateData.BOQMIArea}}</td>
                <td>{{consolidateData.BOQPending}}</td>
                <td></td>
                <td>{{consolidateData.PVCompleted}}</td>
                <td>{{consolidateData.PV_MI_Area}}</td>
                <td>{{consolidateData.PV_Pending_with_JE}}</td>
                <td>{{consolidateData.PV_Pending_with_XEN}}</td>
                <td></td>
                <td>{{consolidateData.Pending_Subsidy_Calculation}}</td>
                <td>{{consolidateData.ApplicationswithDMIforSubsidy_Approval}}</td>
                <td>{{consolidateData.Applications_Approved_at_Administartion}}</td>
                <td>{{consolidateData.Subsisdy_Approved_MI_Area}}</td>
                <td>{{consolidateData.AssistanceAmount}}</td>
                <td></td>
                <td>{{consolidateData.Pending_Application_For_Payment_By_CAO}}</td>
                <td>{{consolidateData.Payment_Done_Application_By_CAO}}</td>
                <td>{{consolidateData.Payment_done_MI_Area}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td >{{totalApp | number:'1.0-2'}}</td>
                <td >{{totalArea | number:'1.0-2'}}</td>
                <td >{{verifiedApp | number:'1.0-2'}}</td>
                <td >{{verifiedAppArea | number:'1.0-2'}}</td>
                <td >{{pendingApp | number:'1.0-2'}}</td>
                <td >{{incompleteApp | number:'1.0-2'}}</td>
                <td >{{incompleteAppArea | number:'1.0-2'}}</td>
                <td >{{rejectApp | number:'1.0-2'}}</td>
                <td></td>
                <td >{{totalEstimatedApp | number:'1.0-2'}}</td>
                <td >{{totalEstimatedArea | number:'1.0-2'}}</td>
                <td >{{pendingEstimateApp | number:'1.0-2'}}</td>
                <td >{{verifiedEstimateApp | number:'1.0-2'}}</td>
                <td >{{verifiedEstimateArea | number:'1.0-2'}}</td>
                <td></td>
                <td >{{verifiedEstApproved | number:'1.0-2'}}</td>
                <td >{{verifiedEstApprovedArea | number:'1.0-2'}}</td>
                <td >{{pendingEstApproved | number:'1.0-2'}}</td>
                <td >{{rejectedEstVerified | number:'1.0-2'}}</td>
                <td></td>
                <td >{{challanGenerated | number:'1.0-2'}}</td>
                <td >{{challanDeposited | number:'1.0-2'}}</td>
                <td></td>
                <td >{{BOQUploaded | number:'1.0-2'}}</td>
                <td >{{BOQMIArea | number:'1.0-2'}}</td>
                <td >{{BOQPending | number:'1.0-2'}}</td>
                <td></td>
                <td >{{PVCompleted | number:'1.0-2'}}</td>
                <td >{{PV_MI_Area | number:'1.0-2'}}</td>
                <td >{{PV_Pending_with_JE | number:'1.0-2'}}</td>
                <td >{{PV_Pending_with_XEN | number:'1.0-2'}}</td>
                <td></td>
                <td >{{pending_Subsidy_Calculation | number:'1.0-2'}}</td>
                <td >{{applicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
                <td >{{applications_Approved_at_Administartion | number:'1.0-2'}}</td>
                <td >{{subsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
                <td >{{assistanceAmount | number:'1.0-2'}}</td>
                <td></td>
                <td >{{pending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
                <td >{{payment_Done_Application_By_CAO | number:'1.0-2'}}</td>
                <td >{{payment_done_MI_Area | number:'1.0-2'}}</td>

            </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td >{{grandTotalApp | number:'1.0-2'}}</td>
                <td >{{grandTotalArea | number:'1.0-2'}}</td>
                <td >{{grandVerifiedApp | number:'1.0-2'}}</td>
                <td >{{grandVerifiedAppArea | number:'1.0-2'}}</td>
                <td >{{grandPendingApp | number:'1.0-2'}}</td>
                <td >{{grandIncompleteApp | number:'1.0-2'}}</td>
                <td >{{grandIncompleteAppArea | number:'1.0-2'}}</td>
                <td >{{grandRejectApp | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandTotalEstimatedApp | number:'1.0-2'}}</td>
                <td >{{grandTotalEstimatedArea | number:'1.0-2'}}</td>
                <td >{{grandPendingEstimateApp | number:'1.0-2'}}</td>
                <td >{{grandVerifiedEstimateApp | number:'1.0-2'}}</td>
                <td >{{grandVerifiedEstimateArea | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandVerifiedEstApproved | number:'1.0-2'}}</td>
                <td >{{grandVerifiedEstApprovedArea | number:'1.0-2'}}</td>
                <td >{{grandPendingEstApproved | number:'1.0-2'}}</td>
                <td >{{grandRejectedEstVerified | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandChallanGenerated | number:'1.0-2'}}</td>
                <td >{{grandChallanDeposited | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandBOQUploaded | number:'1.0-2'}}</td>
                <td >{{grandBOQMIArea | number:'1.0-2'}}</td>
                <td >{{grandBOQPending | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandPVCompleted | number:'1.0-2'}}</td>
                <td >{{grandPV_MI_Area | number:'1.0-2'}}</td>
                <td >{{grandPV_Pending_with_JE | number:'1.0-2'}}</td>
                <td >{{grandPV_Pending_with_XEN | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandPending_Subsidy_Calculation | number:'1.0-2'}}</td>
                <td >{{grandApplicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
                <td >{{grandApplications_Approved_at_Administartion | number:'1.0-2'}}</td>
                <td >{{grandSubsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
                <td >{{grandAssistanceAmount | number:'1.0-2'}}</td>
                <td></td>
                <td >{{grandPending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
                <td >{{grandPayment_Done_Application_By_CAO | number:'1.0-2'}}</td>
                <td >{{grandPayment_done_MI_Area | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
